// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"ec95194b","769":"6b18baac"}[chunkId] + ".chunk.js";
};